import { Users, CalendarDays, ClipboardList, ShieldCheck } from 'lucide-react';

import StatCard from './StatCard';
import './styles/CommitteeStats.css';

const CommitteeStats = () => {
  return (
    <div className="committee-stats">
      <StatCard icon={Users} title="Total Committee" value="32" subtitle="Active governance " trend="+12%" />

      <StatCard icon={CalendarDays} title="Upcoming Meetings" value="8" subtitle="Next 7 days" trend="+8%" />

      {/* <StatCard icon={ClipboardList} title="Active Decisions" value="24" subtitle="Pending actions" trend="+18%" />

      <StatCard icon={ShieldCheck} title="External Approvals" value="14" subtitle="Pending review" trend="+5%" /> */}
    </div>
  );
};

export default CommitteeStats;
